"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.dynamicListings.name': 'Annunci Dinamici',
    'tools.dynamicListings.description': 'Mostra un pannello di annunci contestuale quando viene soddisfatta una specifica condizione della conversazione',
};
